const NotFound = () => {
  return <div style={{ color: "black" }}>No existe la página</div>;
};

export default NotFound;
